import { Modal, ScrollArea } from "@mantine/core";
import { useMemo, useRef } from "react";
import CheckListsForm from "src/generator/_Modals/CheckListsModal/CheckListsForm/CheckListsForm";

import { mapSettingsChecklistToEntry } from "../CheckList.utils";
import { CheckListType, type ICheckListItem } from "../CheckLists.types";
import styles from "./CheckListPreviewModal.module.scss";

interface Props {
  opened: boolean;
  onClose: () => void;
  checklist: ICheckListItem;
  groupItemIndex?: number | null;
}

const CheckListPreviewModal = ({
  opened,
  onClose,
  checklist,
  groupItemIndex = null,
}: Props) => {
  const formRef = useRef<{ save: () => void }>(null);

  const entryChecklist = useMemo(
    () => mapSettingsChecklistToEntry(checklist),
    [checklist],
  );

  const isGroup = checklist.data.type === CheckListType.Group;
  const selectedSubIndex = isGroup ? groupItemIndex : null;

  const renderedDesc = useMemo(() => {
    if (selectedSubIndex !== null && isGroup) {
      const sub = checklist.data.list[selectedSubIndex];
      return sub?.desc || checklist.description || "";
    }
    return checklist.description || "";
  }, [checklist, isGroup, selectedSubIndex]);

  const title = useMemo(() => {
    if (selectedSubIndex !== null && isGroup) {
      const sub = checklist.data.list[selectedSubIndex];
      return sub?.name ? `Preview: ${sub.name}` : "Preview Checklist";
    }
    return `Preview: ${checklist.name}`;
  }, [checklist, isGroup, selectedSubIndex]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title}
      size="xl"
      classNames={{ body: styles.modalBody }}>
      <ScrollArea.Autosize mah="70vh">
        <CheckListsForm
          ref={formRef}
          {...entryChecklist}
          selectedItemIndex={selectedSubIndex}
          renderedDesc={renderedDesc}
          hideEntryDate
          preview
          close={onClose}
          reset={onClose}
        />
      </ScrollArea.Autosize>
    </Modal>
  );
};

export default CheckListPreviewModal;
